// const adminSections = {
//     main: { key: 'main', name: 'Main Options', },
//     website: { key: 'website', name: 'Website Options', },
//     extra: { key: 'extra', name: 'Extra Options', },
//     admin: { key: 'admin', name: 'Admin Options', },
//     // settings: { key: 'settings', name: 'Settings Options', },

// import { energyPages } from "./energyPages"
import { carbonPages } from "./carbonPages"
let result = ""



// }
export function test(params) {
    return result = params

    // if (result == "") {

    // }
    // else {

    // }
}


const carbonWidgets = {


    // "managementOfEnergyCarriers": {
    //     key: 'TableWidget',
    //     page: 'energy',

    //     col: '4',
    //     title: 'Reserved Rentals',
    //     headers: energyPages.managementOfEnergyCarriers.headers,
    //     pages: energyPages.managementOfEnergyCarriers.pages,
    //     // permissionParent: 'permissions',
    //     permissionParent: 'energy.managementOfEnergyCarriers',


    //     fetchUrl: 'getEnergyCarriers',
    //     addUrl: 'postEnergyCarriers',
    //     editUrl: 'postEnergyCarriers',
    //     // removeUrl: 'removeRental',
    //     // populate: ["category"],

    //     // postBody: { "status": '0', archived: { $ne: true } },
    //     actions: {
    //         edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
    //     },

    // },



    // "pendingEquipments": {
    //     key: 'TableWidget',
    //     page: 'tequipments',

    //     col: '12',
    //     title: 'Pending Equipments To Sell',
    //     headers: energyPages.equipments.headers,
    //     permissionParent: 'admin.equipments',

    //     fetchUrl: 'getEquipments',
    //     addUrl: 'addEquipment',
    //     editUrl: 'addEquipment',
    //     removeUrl: 'removeEquipment',
    //     postBody: { "active": { "$ne": '1' } },
    //     populate: ["category"],
    //     actions: {
    //         edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
    //     },
    // },



    // "pendingPartners": {
    //     key: 'TableWidget',
    //     page: 'users',

    //     col: '12',
    //     title: 'Pending Partners',
    //     headers: energyPages.users.headers,
    //     permissionParent: 'admin.users',

    //     fetchUrl: 'getUsers',
    //     addFetch: 'addUser',
    //     removeUrl: 'removeUser',
    //     postBody: { "status": 1 },
    //     actions: {
    //         edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
    //     },

    // },


    // "pendingEnquiries": {
    //     key: 'TableWidget',
    //     page: 'enquiries',

    //     col: '12',
    //     title: 'Pending Enquiries',
    //     headers: energyPages.enquiries.headers,
    //     permissionParent: 'admin.enquiries',

    //     fetchUrl: 'getAll',
    //     addUrl: 'addValue',
    //     editUrl: 'addValue',
    //     removeUrl: 'removeValue',
    //     postBody: { "values.status": '0' },
    //     actions: {
    //         edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
    //     },

    // },


    // "usersActivity": {
    //     key: 'TableWidget',
    //     page: 'logs',

    //     col: '12',
    //     title: 'Users activities',
    //     headers: energyPages.logs.headers,
    //     permissionParent: 'admin.logs',

    //     fetchUrl: 'getInbox',
    //     addUrl: 'addInbox',
    //     editUrl: 'addInbox',
    //     removeUrl: 'removeInbox',
    //     // postBody: { "values.status": 1 },
    //     actions: {
    //         // edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditModal", ref: "invoices", loader: "isPostingData" },
    //     },

    // }





}



export { carbonWidgets }